import { Box } from '@mui/material';
import { FC } from 'react';
import AdminMenu from './AdminMenu';
import DesktopMenuItem from './DesktopMenuItem';
import { AppMenuItem } from './types';

interface DesktopMenuProps {
    appMenuItems: AppMenuItem[];
    adminMenuItems: AppMenuItem[];
    userIsAuthenticated: boolean;
    onCloseNavMenu: () => void;
}

/**
 * Desktop navigation menu (visible on medium+ screens)
 */
const DesktopMenu: FC<DesktopMenuProps> = ({
    appMenuItems,
    adminMenuItems,
    userIsAuthenticated,
    onCloseNavMenu
}) => {
    return (
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {appMenuItems.filter(x => !x.RequireAdmin).map((menuItem) => (
                <DesktopMenuItem
                    key={menuItem.name}
                    menuItem={menuItem}
                    onCloseNavMenu={onCloseNavMenu}
                />
            ))}
            <AdminMenu
                userIsAuthenticated={userIsAuthenticated}
                adminMenuItems={adminMenuItems}
            />
        </Box>
    );
};

export default DesktopMenu;
